import styled from 'styled-components';

export const UiExamResultTable = styled.div`
	display: block;
`;